
import en from './en.json'
import hi from './hi.json'

export const lang={
    en,hi
}
